function getServiceCategoryIds(services){
  return services?.reduce((accumulator, currentValue) => {
    return accumulator.concat(
      currentValue.servicesCategory.nodes.map(({ id }) => id)
    );
  }, []);
}


export default getServiceCategoryIds;